import { render, staticRenderFns } from "./ProductSelectedItem.vue?vue&type=template&id=7c1fcc9c&scoped=true"
import script from "./ProductSelectedItem.vue?vue&type=script&lang=js"
export * from "./ProductSelectedItem.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectedItem.vue?vue&type=style&index=0&id=7c1fcc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1fcc9c",
  null
  
)

export default component.exports